const isBlockedDomain = ({ email, blockedDomains }) => {
  const domain = email?.split("@")[1];
  return blockedDomains.includes(domain);
};

export default isBlockedDomain;
